import { Injectable } from '@angular/core';
import { ServiceBase } from './service-base';
import { MainService } from '../../main.service';
import { AuthService } from '../../auth/auth.service';
import { HttpContext } from '@angular/common/http';
import { SHOW_SPINNER_HTTP_TOKEN } from '../../auth/auth.interceptor';
import { SharedService } from './shared.service';
import { LabelService } from './label.service';
import { LanguageService } from './language.service';
import { ApiConstants } from '../../_models/api-constants';

@Injectable({
  providedIn: 'root'
})
export class CommonService {

  static readonly NO_SPINNER_CONTEXT = new HttpContext().set(SHOW_SPINNER_HTTP_TOKEN, false);

  baseService: ServiceBase | null = null;

  inFullscreen = false;

  constructor(private mainService: MainService, private authService: AuthService, private sharedService: SharedService, private labelService: LabelService, private languageService: LanguageService) {
  }

  logout(): void {
    this.mainService.revokeToken().subscribe(_ => this.authService.logout());
  }

  getProfile(callback?: () => void): void {
    this.sharedService.changePassword = false;

    if (this.sharedService.profile == null) {
      this.mainService.getProfile().subscribe(profile => {
        this.sharedService.profile = profile;

        this.sharedService.showLicenceWarning(profile.showLicenceWarning);

        if (!this.authService.isOathLogin() && !this.authService.isPairedLogin() && !profile.firstPasswordChanged) {
          this.sharedService.changePassword = true;
        }

        if (callback) {
          callback();
        }
      });
    } else {
      if (callback) {
        callback();
      }
    }
  }

  changeFullScreenMode(): void {
    const d = document as any;
    if (d.fullscreenElement || d.webkitFullscreenElement || d.mozFullScreenElement) {
      if (d.exitFullscreen) {
        d.exitFullscreen();
      } else if (d.mozCancelFullScreen) { /* Firefox */
        d.mozCancelFullScreen();
      } else if (d.webkitExitFullscreen) { /* Chrome, Safari and Opera */
        d.webkitExitFullscreen();
      } else if (d.msExitFullscreen) { /* IE/Edge */
        d.msExitFullscreen();
      }
    } else {
      const elem = document.getElementById('content-wrapper') as any;

      if (elem) {
        if (elem.requestFullscreen) {
          elem.requestFullscreen();
        } else if (elem.mozRequestFullScreen) { /* Firefox */
          elem.mozRequestFullScreen();
        } else if (elem.webkitRequestFullscreen) { /* Chrome, Safari and Opera */
          elem.webkitRequestFullscreen();
        } else if (elem.msRequestFullscreen) { /* IE/Edge */
          elem.msRequestFullscreen();
        }
      }
    }
  }

  isFullScreenSupported(): boolean {
    const elem = document.getElementById('content-wrapper') as any;

    return elem && (elem.requestFullscreen || elem.mozRequestFullScreen || elem.webkitRequestFullscreen || elem.msRequestFullscreen);
  }

  fullScreenChanged(): void { // ez mindenfajta fullscreen változást észlel (saját gombunk, google slide gomb, escape-re kilépés stb.)
    // document.fullscreenElement will point to the element that
    // is in fullscreen mode if there is one. If there isn't one,
    // the value of the property is null.
    //window.alert('CHANGED');
    if (document.fullscreenElement || (<any>document).webkitFullscreenElement || (<any>document).mozFullScreenElement) {
      this.inFullscreen = true;
      console.log(`Element: ${(<any>document).fullscreenElement.id} entered fullscreen mode.`);
    } else {
      this.inFullscreen = false;
      console.log("Leaving fullscreen mode.");
    }
  }

  isSamsungBrowser(): boolean {
    let userAgent = navigator.userAgent;
    return userAgent != null && userAgent.match(/SamsungBrowser/i) != null;
  }

  static getPublicResourceUrl(id: number) :string {
    return MainService.replaceId(ApiConstants.API_PUBLIC_ADDRESS_BASE + ApiConstants.API_PUBLIC_GET_RESOURCE, id);
  }

}
